module.exports = __webpack_public_path__ + "static/media/logo-pelican@3x.6e5e2800.png";